var View = require('views/base/view');

var QuestionProgressView = View.extend({
  autoRender: true,
  template: require('./templates/question-progress')
});

module.exports = QuestionProgressView;